import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default class Timeline {
  constructor() {
    this._timeline = document.querySelector('.s-timeline');

    if (this._timeline) {
      this.init();
    }
  }

  init() {
    gsap.registerPlugin(ScrollTrigger);

    const timelineItems = this._timeline.querySelectorAll('.s-timeline-items__item');
    const images = this._timeline.querySelectorAll('.s-timeline-images .c-image');

    if (!timelineItems.length || !images.length) return;

    const imageCount = images.length;
    let currentActiveIndex = -1;


    const updateImages = (activeIndex) => {
      if (activeIndex === currentActiveIndex || activeIndex >= imageCount) return;
      currentActiveIndex = activeIndex;

      images.forEach((img, imgIndex) => {
        let distance = 0;
        let alpha = 0;

        alpha = imgIndex - activeIndex;
        if (alpha < 0) {
          distance = imageCount + alpha;
        } else {
          distance = alpha;
        }

        const zIndex = imageCount - distance;
        const scale = 1 - (distance * 0.04);
        const translateY = -distance * 40;

        gsap.to(img, {
          zIndex: zIndex,
          scale: scale,
          y: translateY,
          x: 0,
          duration: 0.8,
          ease: 'power2.out'
        });
      });
    };

    timelineItems.forEach((item, index) => {
      const targetImageIndex = Math.min(index, imageCount - 1);

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top center-=10%',
          end: 'top center-=10%',
          onEnter: () => updateImages(targetImageIndex),
          onEnterBack: () => updateImages(targetImageIndex),
          scrub: 1
        }
      })


      tl.fromTo(item.querySelector('.dot'), {
          ease: 'power2.out'
        },
        {
          background: '#1E5E42',
          duration: 0.08,
          ease: 'power2.out'
        },
      )
      tl.fromTo(item.querySelector('.dot span'), {
          opacity: 0,
          ease: 'power2.out'
        },
        {
          opacity: 0.2,
          duration: 0.3,
          ease: 'power2.out'
        }
      )
    });

    updateImages(0);
  }
}
